import Routes from './routes'
import AuthLayout from "./pages/layouts/AuthLayout";
import ActionAlerts from './modules/core/components/actionAlerts/ActionAlerts';


function ContentAuthorized() {
    return (
        <AuthLayout>
            <ActionAlerts/>
            <Routes/>
        </AuthLayout>
    )
}

export default ContentAuthorized